import {
  Create,
  SimpleForm,
  useNotify,
  required,
  maxLength,
} from "react-admin";

import { formatImage } from "../../utils/InputUtils";
import { TOPIC_CREATE_TITLE } from "../../constants/titleConstants";
import { TOPIC_HELPER_TEXT } from "../../constants/helperTextConstants";
import { useOnError } from "../../utils/errorUtils";
import { ImageInputField, TextInputField } from "../../styles/commonStyles";
import PreviewImage from "../common/PreviewImage";

const TopicForm = () => (
  <SimpleForm sanitizeEmptyValues>
    <TextInputField
      source="name_en"
      validate={[required(), maxLength(50)]}
      helperText={TOPIC_HELPER_TEXT.nameEn}
    />
    <TextInputField
      source="name_es"
      validate={[maxLength(50)]}
      helperText={TOPIC_HELPER_TEXT.nameEs}
    />
    <TextInputField
      multiline
      source="description_en"
      validate={required()}
      helperText={TOPIC_HELPER_TEXT.descriptionEn}
    />
    <TextInputField
      multiline
      source="description_es"
      helperText={TOPIC_HELPER_TEXT.descriptionEs}
    />
    <ImageInputField
      source="cover_image_url"
      format={formatImage}
      label="Cover Image"
      accept="image/*"
      placeholder={<p>Drop your file here</p>}
      helperText={TOPIC_HELPER_TEXT.coverImage}
    >
      <PreviewImage source="src" />
    </ImageInputField>
  </SimpleForm>
);

const TopicCreate = () => {
  const onError = useOnError(useNotify());
  return (
    <Create
      title={TOPIC_CREATE_TITLE}
      redirect="list"
      mutationOptions={{ onError }}
    >
      {TopicForm()}
    </Create>
  );
};

export { TopicCreate };
